<template>
  <div class="bg-white p-8 pt-5 rounded-lg shadow flex flex-col">
    <eki-error-view
      v-if="error || internalError"
      :error="error || internalError"
      class="mt-5"
    />
    <template v-else>
      <header
        v-if="title || $slots['header']"
        class="relative flex items-center pb-4 mb-6 font-bold text-lg border-b uppercase h-10"
      >
        <a-badge
          v-if="alert"
          status="warning"
          class="absolute transform -translate-x-full"
        />
        <slot name="header" v-bind="{ alert }">
          <label class="flex items-center">
            {{ title }}
            <eki-hint :content="hint" />
            <span
              v-if="readonly"
              class="ml-4 rounded-full px-3 py-1 font-semibold text-xs uppercase bg-gray-200 text-gray-800"
            >
              readonly
            </span>
          </label>
        </slot>
        <div v-if="$slots['header-right']" class="ml-auto">
          <slot name="header-right" />
        </div>
      </header>
      <div v-if="isLoading" class="flex justify-center">
        <a-spin />
      </div>
      <slot v-else />

      <button
        v-if="collapsible"
        class="mt-6 -mx-8 -mb-8 h-12 flex justify-center focus:outline-none items-center bg-gray-300"
        @click="$emit('update:collapsed', !collapsed)"
      >
        <a-icon
          v-if="collapsed"
          type="down-circle"
          theme="twoTone"
          class="text-2xl"
          two-tone-color="#6887b1"
        />
        <a-icon
          v-else
          type="up-circle"
          theme="twoTone"
          class="text-2xl"
          two-tone-color="#6887b1"
        />
      </button>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Panel',

  props: {
    title: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    alert: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: [Error, Object],
      required: false,
      default: null
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      internalError: null
    }
  },
  // eslint-disable-next-line
  errorCaptured(this: any, err, vm, info) {
    this.internalError = err
  }
})
</script>
